import NewsFeed from '../news-feed';

import * as s from './styles';

import type { ITestimonialsTwoColumn } from './types';

const TestimonialsTwoColumn = ({
  backgroundColor, buttons, categoryLink, posts, quoteText = '', attributionLine,
}: ITestimonialsTwoColumn) => (
  <s.Container $backgroundColor={backgroundColor}>
    <s.TwoColumnStyledGrid>
      <s.StyledTestimonialsTwoColumn
        backgroundColor={backgroundColor}
        buttons={buttons}
        quoteText={quoteText}
        attributionLine={attributionLine}
      />
      <NewsFeed
        backgroundColor={backgroundColor}
        categoryLink={categoryLink}
        posts={posts}
      />
    </s.TwoColumnStyledGrid>
  </s.Container>
);

export default TestimonialsTwoColumn;
